export default function PageHeader({ title, subtitle, right, eyebrow }) {
  return (
    <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-3 sm:gap-4 mb-5 sm:mb-6">
      <div className="min-w-0">
        {eyebrow && (
          <div className="p-gold-chip mb-2 sm:mb-3" style={{ fontSize: "9.5px" }}>{eyebrow}</div>
        )}
        <h1
          className="font-black tracking-tight leading-[1.1] p-gold-text"
          style={{ fontSize: "clamp(22px, 5.5vw, 34px)" }}
        >
          {title}
        </h1>
        {subtitle && (
          <div className="text-[12.5px] sm:text-[13.5px] text-white/55 mt-1.5 sm:mt-2 max-w-xl leading-snug">
            {subtitle}
          </div>
        )}
      </div>
      {right && <div className="shrink-0 self-start sm:self-end">{right}</div>}
    </div>
  );
}
